// Custom JavaScript for "twentyfour" theme
import BarBreakdownChartComponent from './shared/charts/bar-breakdown-chart.component';
import DailyPerformanceChartComponent from './shared/charts/daily-performance-chart.component';
import PieBreakdownChartComponent from './shared/charts/pie-breakdown-chart.component';
import Disclosure from './shared/disclosure';
import DocumentsList from './shared/documents-list';
import QuickFinderComponent from './shared/finders/quick-finder.component';
import FormHandler from './shared/form-handler';
import HeaderToggler from './shared/header-toggler';
import KeyFactsComponent from './shared/key-facts.component';
import LinksListComponent from './shared/links-list.component';
import MapStyleChanger from './shared/map-style-changer';
import FundsPage from './shared/page/funds-page';
import PollSubmit from './shared/poll';
import PrivateAccessUrlComponent from './shared/private-access-url.component';
import HistorySliderComponent from './shared/sliders/history-slider.component';
import MediaSliderComponent from './shared/sliders/media-slider.component';
import TeaserSliderComponent from './shared/sliders/teaser-slider.component';
import SlidingMenuComponent from './shared/sliding-menu.component';
import { scrollToElement, scrollToElementOnLoad } from './shared/smooth-scroll';
import TabComponent from './shared/tab.component';
import {
  getIframeHeight,
  hideKeyFactHeaderForEmpty,
  removeDialogButtonFocus,
  scrollToTopAccordion,
} from './shared/utilities';
import { initVideoModal } from './shared/video-modal';
import ViewsExposed from './shared/views.exposed';
import VontobelChosen from './shared/vontobel-chosen';
import '../scss/twentyfour.scss';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './shared/sticky-bits';
import 'bootstrap';

Drupal.behaviors.mytheme = {
  attach(context) {
    new VontobelChosen().init(context);
    if (context !== document) {
      return;
    }

    if (!once('themeJs', 'body', context).length) {
      return;
    }

    const isIE = /MSIE|Trident/.test(navigator.userAgent);
    if (isIE) {
      document.documentElement.classList.add('old-browser');
    }

    new TabComponent().init();
    new Disclosure().init();
    new PrivateAccessUrlComponent().init();
    new SlidingMenuComponent('.corporate-link', '.corporate-nav').init();
    new SlidingMenuComponent('.search-link', '.search-block').init();
    new HistorySliderComponent().init();
    new MediaSliderComponent().init();
    new TeaserSliderComponent().init();
    new MapStyleChanger().init();
    new KeyFactsComponent().init();
    new LinksListComponent().init();
    new HeaderToggler('#header').init();
    new FundsPage().init();
    new FormHandler().init();
    new ViewsExposed().init();
    new DailyPerformanceChartComponent().init();
    if (jQuery('.documents-list').length > 0) {
      new DocumentsList().init();
    }
    new PollSubmit().init();
    new QuickFinderComponent().init();

    window.PieBreakdownChartComponent = PieBreakdownChartComponent;
    window.BarBreakdownChartComponent = BarBreakdownChartComponent;
    scrollToTopAccordion();
    initVideoModal();
    scrollToElementOnLoad();
    removeDialogButtonFocus();
    hideKeyFactHeaderForEmpty();

    jQuery('.mobile-scroll-to-top').on('click', () => {
      scrollToElement('#header');
    });
    window.addEventListener('message', (event) => {
      getIframeHeight(event);
    });
  },
};
